<template>
    <button class="button is-primary is-outlined" v-on:click="signOut">
        {{ $Amplify.I18n.get('Logout') }}
    </button>
</template>

<script>
export default {
    name: 'SignOut',
    data() {
        return {
            error: ''
        }
    },
    methods: {
        signOut: function() {
            this.$Amplify.Auth.signOut()
                .then(() => {
                    this.$store.commit('setUser', null)
                    this.$buefy.toast.open({
                        message: 'ログアウトしました',
                        type: 'is-success'
                    })
                    this.$router.push({ path: '/auth' })
                })
                .catch(e => this.setError(e))
        },
        setError: function(e) {
            this.error = this.$Amplify.I18n.get(e.message || e)
            console.log(this.error)
        }
    }
}
</script>
<style scoped>
.sign-out {
    min-width: 120px;
    text-align: center;
}
</style>
